<template>
  <div class="logo">
    <svg
      id="icons"
      style="width: 50%; overflow: visible"
      version="1.1"
      viewBox="0 0 2068.1 512"
      x="0px"
      xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg"
      y="0px">
      <g>
        <path
          class="st0"
          d="M647,400.1V127.9h95.4c33,0,58.1,6.3,75.2,19c17.1,12.7,25.6,31.2,25.6,55.6s-3.4,25.1-10.3,35.3
		c-6.9,10.2-16.4,17.6-28.6,22.3c14,3.5,25,10.5,33,21.1s12.1,23.6,12.1,38.9c0,26.2-8.4,46-25.1,59.5
		c-16.7,13.5-40.5,20.3-71.4,20.6H647.1L647,400.1z M703.1,241.9h41.5c28.3-0.5,42.5-11.8,42.5-33.8s-3.6-21.2-10.8-26.6
		c-7.2-5.4-18.5-8.1-33.9-8.1h-39.3V241.9L703.1,241.9z M703.1,281.6v73.5h48.1c13.2,0,23.5-3.1,31-9.4c7.4-6.3,11.1-15,11.1-26.1
		c0-24.9-12.9-37.6-38.7-38H703.1L703.1,281.6z" />
        <path
          class="st0"
          d="M947.6,355.1h119.1v45.1H891.5V127.9h56.1L947.6,355.1L947.6,355.1z" />
        <path
          class="st0"
          d="M1158.5,400.1h-56.1V127.9h56.1V400.1L1158.5,400.1z" />
        <path
          class="st0"
          d="M1424.2,309.4c-2.1,29.3-12.9,52.4-32.4,69.2s-45.2,25.2-77.1,25.2s-62.4-11.7-82.4-35.3
		c-20-23.5-30-55.8-30-96.8v-16.6c0-26.2,4.6-49.2,13.8-69.2c9.2-19.9,22.4-35.3,39.6-45.9c17.1-10.7,37.1-16,59.8-16
		s56.7,8.4,75.9,25.2c19.2,16.8,30.3,40.5,33.3,70.9h-56.1c-1.4-17.6-6.3-30.3-14.7-38.2c-8.4-7.9-21.2-11.9-38.4-11.9
		s-32.7,6.7-42,20.1c-9.3,13.4-14.1,34.2-14.3,62.4v20.6c0,29.4,4.5,50.9,13.4,64.5s23,20.4,42.2,20.4s30.3-4,38.8-11.9
		s13.4-20.2,14.7-36.7h56.1L1424.2,309.4z" />
        <path
          class="st0"
          d="M1546.4,290.9l-29.2,31.4v77.8h-56.1V127.9h56.1v123.4l24.7-33.8l69.4-89.6h69l-96.7,121l99.5,151.3h-66.8
		L1546.4,291V290.9z" />
        <path
          class="st0"
          d="M1760.3,355.1h119.1v45.1h-175.2V127.9h56.1V355.1z" />
        <path
          class="st0"
          d="M1971.3,400.1h-56.1V127.9h56.1V400.1L1971.3,400.1z" />
      </g>
      <path
        class="st1"
        d="M256,181.7c-52.2,0-97.2,30.4-118.7,74.3c21.5,44,66.5,74.4,118.7,74.4S353.2,300,374.7,256
	C353.2,212.1,308.2,181.7,256,181.7z" />
      <path
        class="st2"
        d="M173.4,113L173.4,113c-49.4,28.6-82.6,81.9-82.6,143c0,30.1,8.1,58.3,22.2,82.6H113L34.3,384
	C12.5,346.3,0,302.7,0,256C0,161.3,51.4,78.5,128,34.3v0.1L173.4,113z" />
      <path
        class="st3"
        d="M338.6,399.1l45.4,78.6c-37.7,21.8-81.3,34.3-128,34.3c-94.7,0-177.5-51.4-221.7-128l78.7-45.4h0.1
	c28.5,49.4,81.8,82.6,142.9,82.6C286.1,421.2,314.2,413.2,338.6,399.1L338.6,399.1z" />
      <path
        class="st7"
        d="M256,214.7c22.8,0,41.3,18.5,41.3,41.3c0,22.9-18.5,41.4-41.3,41.4s-41.3-18.5-41.3-41.4
	C214.7,233.2,233.2,214.7,256,214.7z" />
      <path
        class="st4"
        d="M421.2,256H512c0,46.7-12.5,90.3-34.3,128L399,338.6h-0.1C413.1,314.3,421.2,286.1,421.2,256z" />
      <path
        class="st5"
        d="M399,338.6l78.7,45.4c-22.5,38.9-54.8,71.3-93.7,93.7l-45.4-78.6l-0.1-0.1C363.6,384.6,384.5,363.7,399,338.6
	L399,338.6z" />
      <path
        class="st6"
        d="M512,256h-90.8c0-91.2-74-165.2-165.2-165.2c-30.1,0-58.3,8.1-82.6,22.2V113L128,34.4v-0.1
	C165.7,12.5,209.3,0,256,0C397.4,0,512,114.6,512,256z" />
      <path
        class="st1"
        d="M256,338.6c-54,0-102.3-30.3-126.1-79c-1.1-2.3-1.1-5,0-7.2c23.8-48.7,72.1-79,126.1-79s102.3,30.3,126.1,79
	c1.1,2.3,1.1,5,0,7.2C358.3,308.3,310,338.6,256,338.6L256,338.6z M146.6,256c21.6,40.9,63.1,66.1,109.4,66.1s87.8-25.2,109.4-66.1
	c-21.6-40.9-63.1-66.1-109.4-66.1S168.2,215.1,146.6,256L146.6,256z" />
      <path
        class="st7"
        d="M256,305.6c-27.3,0-49.5-22.2-49.5-49.6s22.2-49.6,49.5-49.6s49.5,22.2,49.5,49.6S283.3,305.6,256,305.6z
	 M256,223c-18.2,0-33,14.8-33,33s14.8,33,33,33s33-14.8,33-33S274.2,223,256,223L256,223z" />
    </svg>
  </div>
</template>

<script lang="ts" setup></script>

<style scoped>
.st0 {
  fill: #ffffff;
}

.st1 {
  fill: #e6e9ed;
}

.st2 {
  fill: #ed7400;
}

.st3 {
  fill: #f2a766;
}

.st4 {
  fill: #2f6569;
}

.st5 {
  fill: #f0bd70;
}

.st6 {
  fill: #43938a;
}

.st7 {
  fill: #43938a;
}
</style>
